import { useEffect, useRef, useState } from "react";
import { registerDuplicateFoodPrompt, type DuplicateFoodQuestion, type DuplicateFoodChoice } from "../../application/duplicate-food";
import "./duplicate-food.css";

export function DuplicateFoodDialog() {
  const [question, setQuestion] = useState<DuplicateFoodQuestion | null>(null);
  const [selecting, setSelecting] = useState(false);
  const resolver = useRef<((choice: DuplicateFoodChoice) => void) | null>(null);
  const dialog = useRef<HTMLDialogElement>(null);
  const settle = (choice: DuplicateFoodChoice) => {
    const resolve = resolver.current; resolver.current = null;
    dialog.current?.close(); setQuestion(null); setSelecting(false); resolve?.(choice);
  };
  useEffect(() => {
    const unregister = registerDuplicateFoodPrompt(next => new Promise(resolve => {
      resolver.current?.(null); resolver.current = resolve; setSelecting(false); setQuestion(next);
    }));
    return () => { unregister(); resolver.current?.(null); resolver.current = null; };
  }, []);
  useEffect(() => { if (question && dialog.current && !dialog.current.open) dialog.current.showModal(); }, [question]);
  if (!question) return null;
  return <dialog ref={dialog} className="duplicate-food-dialog" aria-labelledby="duplicate-food-title" onCancel={event => { event.preventDefault(); event.stopPropagation(); settle(null); }}>
    <button className="duplicate-food-close" aria-label="Закрыть без изменений" type="button" onClick={() => settle(null)}>×</button>
    <h2 id="duplicate-food-title">{selecting ? "Что изменить?" : "Похожий продукт уже есть"}</h2>
    <p>Вы сказали: <strong>{question.name} · {question.portion}</strong></p>
    {selecting ? <div className="duplicate-food-candidates">{question.matches.map(match => <button type="button" key={match.index} onClick={() => settle(match.index)}>{match.name}<span>{match.portion} · позиция {match.index + 1}</span></button>)}</div> : <>
      <p>В этом приёме пищи: {question.matches.map(match => `${match.name} · ${match.portion}`).join(", ")}. Добавить новую порцию или изменить существующую?</p>
      <div className="duplicate-food-actions"><button type="button" onClick={() => settle("add")}>Добавить</button><button type="button" onClick={() => question.matches.length === 1 ? settle(question.matches[0]!.index) : setSelecting(true)}>Изменить</button></div>
    </>}
  </dialog>;
}
